module.exports = __webpack_public_path__ + "img/academyBg2.734486f6.734486f6.jpg";